import type { FC } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
import useUserDataProvider from "src/contexts/userData-context";
import useWhiteLabelConfig from "src/contexts/config-context";

interface TopAdminProps {
  onMobileNavOpen?: () => void;
}

export const TopAdmin: FC<TopAdminProps> = () => {
  const { userData } = useUserDataProvider();
  const { dashboard_domain } = useWhiteLabelConfig();

  const openDashboard = () => {
    // Route to the professional group's white-labeled dashboard domain when the
    // firm is branded; fall back to the default Snug dashboard otherwise.
    const default_dashboard_domain =
      process.env.REACT_APP_SNUG_ENV === "PRODUCTION"
        ? "dashboard.getsnug.com"
        : "dashboard.staging.getsnug.com";
    const professional_dashboard_domain =
      dashboard_domain || default_dashboard_domain;
    const link = `https://${professional_dashboard_domain}/?at=${localStorage.getItem(
      "s_at"
    )}`;
    window.open(link, "_blank");
  };

  return (
    <Box
      component="header"
      sx={{
        position: "fixed",

        top: 0,
        width: `100%`,
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          backgroundColor: "primary.main",
          py: 0.7,
          color: "primary.contrastText",
          height: "48px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container maxWidth={"lg"} sx={{ height: "100%" }}>
          <Stack
            direction="row"
            spacing={2}
            alignItems={"center"}
            textAlign={"left"}
            justifyContent={"center"}
            sx={{ height: "100%" }}
          >
            <Typography variant="button" sx={{ textTransform: "none" }}>
              {`You are viewing and contributing to ${userData?.full_name}'s plan.`}
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<ArrowOutwardOutlinedIcon />}
              onClick={openDashboard}
              sx={{
                py: 0.3,
                px: 1.5,
                fontSize: "0.75rem",
                borderRadius: 0.6,
                color: "primary.contrastText",
                borderColor: "rgba(255, 255, 255, 0.5)",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                "&:hover": {
                  borderColor: "primary.contrastText",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                },
              }}
            >
              Open dashboard
            </Button>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

TopAdmin.propTypes = {
  onMobileNavOpen: PropTypes.func,
};
